module.exports = __webpack_public_path__ + "static/media/id-card-alt.9378e41f.svg";